import { Component } from '@angular/core';

@Component({
  selector: 'rmi-how-about-improvements',
  templateUrl: './how-about-improvements.component.html',
  styleUrls: ['./how-about-improvements.component.scss']
})
export class HowAboutImprovementsComponent {
}
